import { useEffect, useState } from "react";
import { _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_MONEY } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { _Fortnight, _IncapacityLiquidation } from "../../../../core/services/dataBean/EntityCatalogVdos";
import usePaginator from "../../../theme/Component/usePaginator";
import { toast } from "react-toastify";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { SelectMonths } from "../../../contract/select/SelectMonths";
import { WelfareEntityEditor } from "../EmployeeContract/ComponentsContract/EditorsEmployeContrac/WelfareEntityEditor";
import { AdminProcess } from "../../../erp/cellEditor/PaymentHeader/AdminProcess";
import { AccountEditor } from "../../../editor/AccountEditor";
import { IncapacityLiquidateSelector } from "../../ParametrosTalentoHumano/ImportedPayrollConcept/EditorsySelectors/IncapacityLiquidate.Selector";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { InputDate } from "../../../theme/Input/InputDate";
import { ErrorList } from "../../../theme/Component/ErrorList";
import { DocumentViewer } from "../../../theme/Component/DocumentViewer";
import { DropDown } from "../../../theme/Component/DropDown";
import { ExportXLSL } from "../../../theme/Component/ExportXLSX";
import { WelfareEntityEditorTable } from "../../WelfareEntity/WelfareEntityEditorTable";
import { WelfarePaymentByIncapacity } from "./WelfarePaymentByIncapacity";

interface PropsForm {
    Year: number;
    Month: number;
    welfareID?: number;
    idProcess?: number;
    idEmployee?: number;
    fortnightType?: number;
}

interface ComponentData {
    isModal?: boolean;
    _onChange?: Function;
}

export const FortnightLiquidation = ({ _onChange, isModal }: ComponentData) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_Fortnight);
    const liquidate = useDataBean(_IncapacityLiquidation)
    const [modal, setModal] = useState<any>({ name: 'Liquidar Incapacidad', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalconsultar, setModalconsultar] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalCSV, setModalCSV] = useState<any>({ name: 'Reporte', tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-sm' });
    const [modalVisor, setModalVisor] = useState<any>({ name: 'Documento de Liquidación de Incapacidad', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [form, setForm] = useState<PropsForm>({
        Month: _single.getCurrentMonth(),
        Year: _single.getCurrenYear(),
    })
    const [formliq, setFormliq] = useState<any>({
        AccountantDate: _single.getCurrenDate()

    })
    const [listaExport, setListaExport] = useState([]);

    const [documents, setDocuments] = useState<any>([]);
    const [msgList, setMsgList] = useState<any>([]);
    const paginator = usePaginator();

    useEffect(() => {
        getLista()
    }, [paginator.page])

    const getLista = () => {
        instance.getFortnightIncapacitiesToLiquidate(form.Year, form.Month, form.welfareID, form.idProcess, form.idEmployee, form.fortnightType, paginator.page, 15).then(
            (reps) => {
                setLista(reps.List)
                paginator.setPages(reps.NumberOfPages);
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    const getListaExport = () => {
        instance.getFortnightIncapacitiesToLiquidate(form.Year, form.Month, form.welfareID, form.idProcess, form.idEmployee, form.fortnightType, null, null).then(
            (reps) => {
                setListaExport(reps.List)
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    const Liquidate = () => {
        liquidate.instance.createIncapacityLiquidation(formliq.AccountantDate, bean.IDDocument, bean.DocumentDate, bean.NoveltyID, bean.IDWelfareEntity, bean.Description, _single.getAccountID()).then(
            (resp) => {
                setDocuments(resp.DocumentURL);
                setMsgList(resp.MsgList);
                setModalVisor({ ...modalVisor, view: true, Obj: resp });
                setModal({ ...modal, view: false });
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    const head = [
        { title: 'Liquidado', property: 'IncapacityLiquidated', visible: true },
        { title: 'Doc Liquidación', property: 'DocumentCNAName', visible: true },
        { title: 'Fecha Documento', property: 'DocumentDate', visible: true },
        { title: 'Identificación  Empleado', property: 'EmployeeID', visible: true },
        { title: 'Empleado', property: 'EmployeeName', visible: true },
        { title: 'Identificación Fondo', property: 'DebtAccountID', visible: true },
        { title: 'Entidad', property: 'DebtAccountName', visible: true },
        { title: 'Entidad Actualizada', property: 'IncapacityAccountName', visible: true },
        { title: 'Cuenta Contable', property: 'DebtAccountantIDStr', visible: true },
        { title: 'Tipo Novedad', property: 'FortnightTypeName', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Unidades', property: 'Units', visible: true },
        { title: 'Valor', property: 'Value', visible: true, mask: MASK_MONEY },
        { title: 'Valor Consignado', property: 'PaidValue', visible: true },
        { title: 'Descripción', property: 'IncapacityDescription', visible: true },
        { title: 'Fecha de Pago', property: 'IncapacityUptoDate', visible: true },
        { title: 'Observaciones', property: 'IncapacityObservations', visible: true },
        { title: 'Fecha Inicial Incapacidad', property: 'IncapacityFromDate', visible: true },
        { title: 'Fecha Final Incapacidad', property: 'IncapacityDescription', visible: true },
    ]


    const listaBotones = () => {
        const botones = [

            { titulo: 'Liquidar Incapacidad', icono: 'ri-file-upload-fill', visible: isModal ? false : _single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Consultar Pagos Realizados por la Entidad', icono: 'ri-file-unknow-line', visible: isModal ? false : _single.canEdit(), evento: () => { setModalconsultar({ ...modalconsultar, "view": true }) } },
            { titulo: 'Ver Documento de Liquidación de Incapacidad', icono: 'ri-file-search-line', visible: bean.IDDocumentCNA, evento: () => { getDocument() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    const getDocument = () => {
        instance.getPdfAccountantDocument(bean.IDDocumentCNA, bean.MnemonicCNA, bean.DocumentDateCNA, _single.getAccountID()).then(
            (resp) => {
                setDocuments(resp.DocumentURL);
                setModalVisor({ ...modalVisor, "view": true })
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const actionsDropDown = [
        { id: 1, name: 'Descargar Detallado', permiso: null, activo: true },
    ];

    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    {_single.canExport() &&
                        <DropDown lista={actionsDropDown} eventClick={actions}></DropDown>
                    }

                </div>
            </div>
        )
    }

    const actions = (e: any) => {

        if (e.id === 1) {
            getListaExport();
            setModalCSV({ ...modalCSV, "view": true });
        }
    }

    const setValue = (e) => {
        _onChange?.(e);
        setBean(e);
    }
    const baseComponent = () => {

        return (
            <div className="row">
                <div className="col-md-6">
                    <YearSelector value={form.Year} onChange={(e) => { setForm({ ...form, Year: e }) }} tittle="Año" />
                </div>
                <div className="col-md-6">
                    <SelectMonths idSelector={form.Month} onChange={(e) => { setForm({ ...form, Month: e }) }} label="Mes" />
                </div>
                <div className="col-md-6">
                    <WelfareEntityEditor idSelector={form.welfareID} onChange={(e) => { setForm({ ...form, welfareID: e.IDWelfareEntity }) }} label="Entidad a Cargo" />
                </div>
                <div className="col-md-6">
                    <AdminProcess returnType="ID" processType={4} idSelector={form.idProcess} label="Proceso" onChange={(e) => { setForm({ ...form, idProcess: e.IDProcess }) }} />
                </div>
                <div className="col-md-6">
                    <AccountEditor idAccount={form.idEmployee} label="Empleado" onChange={(e) => { setForm({ ...form, idEmployee: e.IDAccount }) }} />
                </div>
                <div className="col-md-6">
                    <IncapacityLiquidateSelector idSelector={form.fortnightType} onChange={(e) => { setForm({ ...form, fortnightType: e }) }} label="Tipo Incapacidad" />
                </div>
                <div className="col-md-6 mt-4">
                    <BasicButton eventClick={getLista} icon="ri-search-line" children={"Buscar"} />
                </div>
                <div className="col-md-12">
                    <BasicTable headButtons={buttons()} listButtons={listaBotones()} head={head} body={lista} rowSet={setValue} records={paginator} />
                </div>


                <div className="col-md-12">
                    <Modal modal={modal} updateModal={setModal} eventModal={Liquidate}>
                        <div className="row">
                            <div className="col-md-6">
                                <label >Fecha de Registro Contable</label>
                                <InputDate name="AccountantDate" label=" " value={formliq.AccountantDate} setDate={(e) => { setFormliq({ ...formliq, AccountantDate: e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label >Entidades de Seguridad Social</label>
                                <WelfareEntityEditorTable render={bean.NameWell} idSelector={bean.IDWelfareEntity} onChange={(e) => { setBean({ ...bean, "IDWelfareEntity": e.IDWelfareEntity, "NameWell": e.AccountName }) }} label=" " returnType="Object" />
                                {/* <AccountEditor idAccount={bean.IDAccount} label="Empleado" onChange={(e) => { setBean({ ...bean, IDAccount: e.IDAccount }) }} /> */}
                            </div>
                            {/* <div className="col-md-6">
                                <label className={`${missingFields.includes('PaidValue') ? 'has-error' : ''}`}>Valor Consignado</label>
                                <InputMoney _value={bean.PaidValue} onChange={(e) => { setBean({ ...bean, PaidValue: e }) }} _label="" />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('PaymentDate') ? 'has-error' : ''}`}>Fecha de Pago</label>
                                <InputDate name="PaymentDate" label="" value={bean.PaymentDate} setDate={(e) => { setBean({ ...bean, PaymentDate: e }) }} />
                            </div> */}
                            <div className="col-md-12">
                                <label >Descripción</label>
                                <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} ></textarea>
                            </div>

                        </div>
                    </Modal>
                </div>

                <div className="col-md-12">
                    <Modal modal={modalVisor} updateModal={setModalVisor}>
                        <div className="row">
                            <div className="col">
                                {msgList?.length > 0 &&
                                    <ErrorList lista={msgList} />
                                }
                                {msgList?.length === 0 && documents.length > 0 &&
                                    <DocumentViewer key={documents} list={documents} />
                                }
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalconsultar} updateModal={setModalconsultar}>
                        <div className="row">
                            <WelfarePaymentByIncapacity idDocument={bean.IDDocument} documentDate={bean.DocumentDate} NoveltyID={bean.NoveltyID} />
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalCSV} updateModal={setModalCSV}>
                        <div className="row">
                            <div className="col">
                                {lista.length > 0 &&
                                    <ExportXLSL customName={"Incapacidades Laborales"} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaExport} onExport={(name: string) => {
                                        _single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                                    }} />
                                }
                            </div>
                        </div>
                    </Modal>
                </div>

            </div>
        )
    }

    return isModal ? (
        baseComponent()
    ) : (
        <BasicPage titulo="Incapacidades Laborales">
            {baseComponent()}
        </BasicPage>
    );
}